import {FormControl, FormHelperText, MenuProps, Select, SelectProps, Stack, Typography, styled} from '@mui/material';
import {ReactNode, forwardRef} from 'react';

const Label = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 14,
  color: '#374151',
}));

const StyledFormControl = styled(FormControl)(() => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#FFFFFF',
  },
}));

const SelectField = styled(Select)(() => ({
  '& .MuiSelect-select': {
    minHeight: '41px !important',
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: 16,
  },
}));

interface SimpleSelectFieldProps extends Omit<SelectProps<unknown>, 'label' | 'variant'> {
  label: ReactNode;
  helperText?: ReactNode;
}

export const SimpleSelectField = forwardRef<HTMLInputElement, SimpleSelectFieldProps>(
  ({label, helperText, error, children, ...props}, ref) => {
    const {MenuProps, ...selectProps} = props;

    const mergedMenuProps: Partial<MenuProps> = {
      disablePortal: true,
      anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
      transformOrigin: {vertical: 'top', horizontal: 'left'},
      marginThreshold: null,
      ...MenuProps,
    };

    return (
      <Stack gap="4px" width="100%">
        <Label>{label}</Label>
        <StyledFormControl fullWidth error={error}>
          <SelectField variant="outlined" inputRef={ref} MenuProps={mergedMenuProps} {...selectProps}>
            {children}
          </SelectField>
          {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
        </StyledFormControl>
      </Stack>
    );
  },
);

SimpleSelectField.displayName = 'SimpleSelectField';
